import { useEffect, useState } from "react";

// Keep editable text independent from the committed, validated numeric value.
export default function NumberDraft({ value, onChange, min, max, ...props }) {
  const [text, setText] = useState(String(value));
  useEffect(() => setText(String(value)), [value]);
  const commit = (source) => {
    if (source.trim() === "" || !Number.isFinite(Number(source))) {
      setText(String(value));
      return;
    }
    const number = Math.max(
      min ?? -Infinity,
      Math.min(max ?? Infinity, Number(source)),
    );
    setText(String(number));
    onChange(number);
  };
  return (
    <input
      {...props}
      type="number"
      min={min}
      max={max}
      value={text}
      onChange={(e) => {
        const next = e.target.value;
        setText(next);
        if (
          next !== "" &&
          Number.isFinite(Number(next)) &&
          Number(next) >= (min ?? -Infinity) &&
          Number(next) <= (max ?? Infinity)
        )
          onChange(Number(next));
      }}
      onBlur={() => commit(text)}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit(text);
      }}
    />
  );
}
